import {createSlice} from '@reduxjs/toolkit';

import {pinBuilder} from './reducer';

const initialState: any = {
  loading: 0,
  availablePinsLoading: false,
  error: '',
  pin: {},
  pins: [],
  pinRegions: [],
  maxExpressDeliveryDistance: null,
  polygonBoundaries: null,
  availablePins: [],
  pinBasket: [],
  payment: {},
  confirmPaymentLoading: false
};

export const pinSlicer = createSlice({
  name: 'pin',
  initialState,
  reducers: {},
  extraReducers: pinBuilder
});

export default pinSlicer.reducer;
